// extracted by mini-css-extract-plugin
export default {"TabsUi":"CrmTabs_TabsUi__NY4ct","style":"CrmTabs_style__ITEIp","active":"CrmTabs_active__F7t2p","ant-space-item":"CrmTabs_ant-space-item__N0hb3"};